<template>

	<div class="btn-group" :class="{
		'tab-styling':tabStyling
	}" v-if="!readonly">
		<button v-for="(button,index) in buttons" type="button" class="btn" :class="{
				active: activeIndex==index,
				'btn-primary': activeIndex == index,
				'btn-light': activeIndex != index,
				'btn-lg' : largeButtons
			}"
			:title="'title' in button ? button.title : false"
			v-on:click="input(button.value, index)">
			<i v-if="'icon' in button" class="fa" :class="button.icon"></i>
			{{button.text}}
		</button>
	</div>
	<div v-else>

		<div v-if="button.value == value"
			v-for="(button,index) in buttons" 
			:title="'title' in button ? button.title : false"
			class="form-control-plaintext">
			<i v-if="'icon' in button" class="fa" :class="button.icon"></i>
			{{button.text}}
		</div>
	</div>

</template>

<script type="text/javascript">

	export default {
		name: "ButtonGroup",
		props: [
			"value",
			"buttons", //ARRAY of [{value,text}]
			"largeButtons",
			"readonly",
			"tabStyling",
			"disableNull"
		],
		data() {
			return {
				activeIndex: null
			}
		},
		methods: {
			input(value, index) {
				if (this.buttons[index].value == this.value && this.activeIndex !== null && !this.disableNull) {
					//deselect
					value = null
					this.activeIndex = null
				}
				else 
					this.activeIndex = index

				this.$emit("input",value)
				this.$emit("change",value)
			}
		},
		watch: {
			value() {
				let vm = this
				this.buttons.forEach(function(button, index){
					if (button.value == vm.value)
						vm.activeIndex = index
				})
			}
		},
		mounted() {
			//loop through buttons to match prop value to button value
			let vm = this
			if (this.buttons) {
				this.buttons.forEach(function(button, index){
					if (button.value === vm.value)
						vm.activeIndex = index
				})
			}
		}
	}
</script>

<style type="text/css" scoped>

	.tab-styling .btn-primary,
	.tab-styling .btn-light {
		border-radius: 0;
	}

	.btn-group {
		flex-wrap: wrap;
		margin-top: 0;
	}

	.btn-group .active {
		background-color: #428bca;
		color: white;
		text-shadow: none;
	}

	.btn-group-vertical>.btn.active, .btn-group-vertical>.btn:active, .btn-group-vertical>.btn:focus, .btn-group>.btn.active, .btn-group>.btn:active, .btn-group>.btn:focus {
		z-index: 0;
	}

	.btn-group button {
		margin: 0;
		flex-grow: 1;
	}

	.btn-group.tab-styling button {
		flex-grow: initial;
	}

	.btn-group.tab-styling .btn {
		background-color: transparent;
		color: #88867F;
		border: none;
		border-bottom: 2px solid #88867F;
	}

	.btn-group.tab-styling .btn.active, 
	.btn-group.tab-styling .btn:hover,
	.btn-group.tab-styling .btn-group.tab-styling .btn:focus, 
	.btn-group.tab-styling .btn-primary:not([disabled]):not(.disabled).active {
		border:none!important;
		border-bottom: 2px solid var(--brand-primary-color)!important;
		color: var(--brand-primary-color);
		background-color: transparent!important;
		box-shadow: none!important;
		border-radius: 0;
	}

	.btn-group.tab-styling .btn.active:focus {
		box-shadow: none;
	}

	.form-control-plaintext .fa {
		font-size: 16pt;
	}

</style>